<template>
    <div class="download">
        <p v-if="data.text" class="download-text">
            {{ data.text }}
        </p>
        <div v-if="data.button" class="download-button">
            <a-button v-bind="data.button" />
        </div>
    </div>
</template>

<script setup lang="ts">
import AButton from '@core/components/button/button.vue';
import type { BodyVariant, DownloadToolData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockDownload',
});

defineProps<{
    id?: string;
    data: DownloadToolData;
    variant: BodyVariant;
}>();
</script>

<style lang="pcss" scoped>
.body-renderer .download {
    gap: 16px;
    display: flex;
    padding: 16px;
    margin: 40px 0;
    border-radius: 8px;
    align-items: center;
    background: var(--av-solid-brand-lightest);
    border: 1px solid var(--av-brand-secondary-light);

    @media (--viewport-tablet) {
        gap: 48px;
        padding: 32px 40px;
    }
}

/* resource bodies wrap every block in a div */
.body-renderer > .download:first-child,
.body-renderer > div:first-child > .download {
    margin-top: 8px;
}

.body-renderer .download-text {
    @mixin paragraph-accent;
    margin: 0;
    min-width: 0;
    flex: 1 1 auto;
    overflow-wrap: anywhere;
    color: var(--av-nav-primary);
}

.body-renderer .download-button {
    flex-shrink: 0;
}
</style>
